module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/bp-3-512.35713f30e41bd99e.jpg"+" 512w",
        images: [{path: "https://static.sniffspot.com/packs/img/bp-3-512.35713f30e41bd99e.jpg",width: 512,height: 342}],
        src: "https://static.sniffspot.com/packs/img/bp-3-512.35713f30e41bd99e.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/bp-3-512.35713f30e41bd99e.jpg"},
        
        width: 512,
        height: 342
      }